import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class ParallaxImage {
  constructor() {
    this._imagesEl = document.querySelectorAll(".s-c-t-a-image-text-custom");

    if (this._imagesEl.length > 0) {
      this.init();
    }
  }

  init() {
    gsap.registerPlugin(ScrollTrigger);

    this._imagesEl.forEach((image) => {
      let imgEl = image.querySelector("img");

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: imgEl,
          start: "top bottom",
          end: "bottom+=50% bottom",
          scrub: 2,
        },
      });

      tl.fromTo(
        imgEl,
        {
          scale: 1.1,
        },
        {
          scale: 1,
          duration: 1,
          ease: "none",
        }
      );
    });
  }
}
